'use client';

import React from 'react';

import { HStack, Stack, Tag, TagLabel, Text } from '@chakra-ui/react';

import CustomText from './CustomText';

interface TextDetailProps {
    heading: string;
    values: string[];
    variant?: string;
    colorScheme?: string;
    weight?: number;
    color?: string;
    tagBorderColor?: string;
    tagColor?: string;
    tagBgColor?: string;
    tagFontWeight?: number;
}

const CustomTag = ({
    heading,
    values,
    variant,
    colorScheme,
    weight = 400,
    tagBorderColor,
    tagBgColor,
    tagColor,
    color = 'subText',
    tagFontWeight = 400,
}: TextDetailProps) => (
    <Stack gap={1}>
        <CustomText size="md" color={color} weight={weight}>
            {heading}
        </CustomText>
        <HStack spacing={2} flexWrap="wrap">
            {values && values.length > 0 ? (
                values.map(item => (
                    <Tag
                        size="md"
                        key={item}
                        borderWidth={1}
                        borderColor={tagBorderColor}
                        color={tagColor}
                        bgColor={tagBgColor}
                        fontWeight={tagFontWeight}
                        colorScheme={colorScheme}
                        variant={variant}
                        py={1}
                        px={2}
                    >
                        <TagLabel fontSize='12px' lineHeight='16px'>{item}</TagLabel>
                    </Tag>
                ))
            ) : (
                <Text fontSize="md" color="mainText">
                    -
                </Text>
            )}
        </HStack>
    </Stack>
);

export default CustomTag;
